import { render, staticRenderFns } from "./fwUpdateDetail.vue?vue&type=template&id=6a02f670&scoped=true"
import script from "./fwUpdateDetail.vue?vue&type=script&lang=js"
export * from "./fwUpdateDetail.vue?vue&type=script&lang=js"
import style0 from "./fwUpdateDetail.vue?vue&type=style&index=0&id=6a02f670&prod&lang=scss&scoped=true"
import style1 from "./fwUpdateDetail.vue?vue&type=style&index=1&id=6a02f670&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a02f670",
  null
  
)

export default component.exports